/* global axios */
import ApiClient from './ApiClient';

export const buildClientParams = (page, sortAttr, label, search) => {
  let params = `include_client_inboxes=false&page=${page}&sort=${sortAttr}`;
  if (search) {
    params = `${params}&q=${search}`;
  }
  if (label) {
    params = `${params}&labels[]=${label}`;
  }
  return params;
};

class ClientAPI extends ApiClient {
  constructor() {
    super('clients', { accountScoped: true });
  }

  get(page, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}?${buildClientParams(
      page,
      sortAttr,
      label,
      ''
    )}`;
    return axios.get(requestURL);
  }

  show(id) {
    return axios.get(`${this.url}/${id}?include_client_inboxes=false`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}?include_client_inboxes=false`, data);
  }

  getConversations(clientId) {
    return axios.get(`${this.url}/${clientId}/conversations`);
  }

  getClientableInboxes(clientId) {
    return axios.get(`${this.url}/${clientId}/clientable_inboxes`);
  }

  getClientLabels(clientId) {
    return axios.get(`${this.url}/${clientId}/labels`);
  }

  updateClientLabels(clientId, labels) {
    return axios.post(`${this.url}/${clientId}/labels`, { labels });
  }

  search(search = '', page = 1, sortAttr = 'name', label = '') {
    let requestURL = `${this.url}/search?${buildClientParams(
      page,
      sortAttr,
      label,
      search
    )}`;
    return axios.get(requestURL);
  }

  active(page = 1, sortAttr = 'name') {
    let requestURL = `${this.url}/active?${buildClientParams(page, sortAttr)}`;
    return axios.get(requestURL);
  }

  // eslint-disable-next-line default-param-last
  filter(page = 1, sortAttr = 'name', queryPayload) {
    let requestURL = `${this.url}/filter?${buildClientParams(page, sortAttr)}`;
    return axios.post(requestURL, queryPayload);
  }

  importClients(file) {
    const formData = new FormData();
    formData.append('import_file', file);
    return axios.post(`${this.url}/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroyCustomAttributes(clientId, customAttributes) {
    return axios.post(`${this.url}/${clientId}/destroy_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  destroyAvatar(clientId) {
    return axios.delete(`${this.url}/${clientId}/avatar`);
  }

  exportClients(queryPayload) {
    return axios.post(`${this.url}/export`, queryPayload);
  }
}

export default new ClientAPI();
